export const subscriptionGetters = {
  allSubscriptions: (state) => state.allSubscriptions,
  selectedSubscription: (state) => state.selectedSubscription,
  subscriptionForm: (state) => state.subscriptionForm,
};
